import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/$org/user')({
    component: UserLayout,
})

function UserLayout() {
    return <Outlet />
}
